











































import customerExperienceAppointmentDashboard from '@/components/home/customer-experience-appointment-dashboard.vue';
import customerExperienceCallDashboard from '@/components/home/customer-experience-call-dashboard.vue';
import taskDashboard from '@/components/home/task-dashboard.vue';
import loading from '@/components/loading.vue';
import toggleButton from '@/components/toggle-button.vue';
import layout from '@/layouts/app.vue';
import { RoleName } from '@/shared/role-name';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        customerExperienceAppointmentDashboard,
        customerExperienceCallDashboard,
        taskDashboard,
        layout,
        loading,
        toggleButton,
    },
})
export default class CustomerExperienceDashboard extends Vue {
    private defaultUserRoleName = RoleName.CustomerExperienceExecutive;
}
